import { ScoreGauge } from "./ScoreGauge";
export default ScoreGauge;
